module.exports = __webpack_public_path__ + "img/img2.e5ffa91b.svg";